import { IconNameV1 } from 'common/icon/iconV1.js';
import { Observation } from 'components-modules/map-slot-marker-description/observation.js';
import { CompassDirection } from 'types/compass-direction';
import { ISummary } from 'types/markerTypes/location.summary';
import { TIME_FORMATS, formatDate } from 'utilities/date.js';
import { isNotNullOrUndefined } from 'utilities/isType.js';
import { getRating } from 'utilities/status/rating.js';

export type BoatingPanelProps = Pick<
  ISummary,
  'rating' | 'wind' | 'swell' | 'period' | 'chop' | 'setFace' | 'waveHeight'
> & {
  date?: string;
  sea?: { seaHeight: number; direction: CompassDirection };
};

const getBoatMetaData = (rating: string | number | undefined): { icon: IconNameV1; label: string } => {
  if (rating) {
    const { label, icon: ratingIcon } = getRating(rating);
    const icon = `boating-${ratingIcon}`.toLowerCase() as IconNameV1;
    return { label, icon };
  }

  return { icon: 'boating', label: '' };
};

export const BoatingPanel = ({ value }: { value: BoatingPanelProps }) => {
  const { rating, wind, swell, sea, period, chop, date } = value;
  const { icon, label } = getBoatMetaData(rating);

  return (
    <div className="u-mT-sm" data-comp="boating-mk-desc">
      {date && (
        <small className="u-textGrey u-inlineBlock fineprint u-mB-sm">{`Forecast for ${formatDate(
          date,
          TIME_FORMATS.HourAMPM,
        )}`}</small>
      )}
      <Observation name={icon} label="Sea condition" value={`${label} ${rating}`} />

      {wind && (
        <Observation
          name="wind"
          label="Wind forecast"
          value={
            <>
              {wind.averageSpeed}kts {wind.direction}
              {isNotNullOrUndefined(wind.gustSpeed) && (
                <>
                  <br />
                  Gusts {wind.gustSpeed}kts
                </>
              )}
            </>
          }
        />
      )}

      {sea && <Observation name="sea" label="Sea" value={`${sea.seaHeight}m ${sea.direction}`} />}
      {isNotNullOrUndefined(chop) && <Observation name="chop-height" label="Chop height" value={`${chop}m`} />}
      {swell && <Observation name="swell" label="Swell" value={`${swell.swellHeight}m ${swell.direction}`} />}
      {isNotNullOrUndefined(period) && <Observation name="periods" label="Period" value={`${period}sec`} />}
    </div>
  );
};
